<template>
    <div class="marker-container" @click="onClick">
        <svg viewBox="0 0 36 36">
            <circle class="marker-circle" cx="18" cy="18" r="6" fill="#042d36" />
        </svg>
    </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
    name: "MaintenanceMarker",
    props: {
        id: {
            type: Number,
        },
    },
    methods: {
        onClick() {
            this.$emit("marker-click", { id: this.id });
        },
    },
});
</script>

<style lang="scss" scoped>
.marker-circle {
    stroke: white;
    stroke-opacity: 0.5;
    stroke-width: 2;
}
.marker-container {
    width: 24px;
    height: 24px;
    cursor: pointer;
    text-align: center;
    top: -12px;
}
</style>
